import { render, staticRenderFns } from "./ImagesSlide.vue?vue&type=template&id=1f87bbf9&scoped=true&"
import script from "./ImagesSlide.vue?vue&type=script&lang=js&"
export * from "./ImagesSlide.vue?vue&type=script&lang=js&"
import style0 from "./ImagesSlide.vue?vue&type=style&index=0&id=1f87bbf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f87bbf9",
  null
  
)

export default component.exports